module.exports = __webpack_public_path__ + "static/media/atypical-pattern-2-1056-faster.907c3c2f.gif";